(() => {
  'use strict';

  const rootSelector = '[data-fd-product][data-fd-required-jump="true"]';
  // Snapshot of the 411 currently published custom window treatments approved for this rollout.
  const allowedProductIds = new Set('8929288847610|8930972631290|8940563103994|8727547379962|8667472199930|8927233900794|8927198675194|8719728148730|8667528593658|8726177448186|8932788109562|8731187544314|8733247045882|8938162979066|8938080207098|8920338006266|8921235226874|8918943367418|8738283356410|8934582321402|8940568051962|8955432304890|8919630283002|8940568674554|8929287766266|8940567331066|8938079846650|8739091185914|8907308466426|8905648275706|8907307811066|8905643491578|8911850963194|8903312408826|8911853781242|8938129162490|8926365483258|8925667262714|8925667918074|8926277632250|8925661823226|8926296637690|8926305321210|8926273011962|8923750564090|8923794342138|8919052222714|8738287943930|8929289928954|8934627574010|8929287504122|8923780481274|8938086400250|8903145226490|8905749332218|8688564699386|8920343445754|9238056272122|8934696517882|8672823116026|8924456648954|8912701260026|8919690084602|8921194758394|8679078297850|8938177462522|8930974499066|9267950682362|9267950715130|9267953434874|9267951829242|9267953565946|9267951862010|9267953729786|9267951927546|9267950878970|9267953893626|9267951993082|9267954057466|9267952615674|9267950944506|9267954909434|9267952779514|9267955106042|9267952845050|9267955269882|9267952943354|9267955826938|9267953107194|9267957104890|9267953205498|8934701334778|9267957268730|9267957367034|9267964739834|9267957858554|9267965395194|9267957989626|9267965821178|9267958153466|9267966804218|9267958448378|9267967983866|9267958808826|9267957498106|9267969032442|9267959628026|9267970081018|9267960709370|9267972997370|9267961528570|9267957629178|9267974537466|9267962577146|9267975684346|9267963068666|9267976372474|9267963592954|9267977421050|9267964182778|8937431007482|8937430253818|8932810096890|9238055649530|8933322293498|8680109310202|8680116846842|8680508653818|8680500560122|9267978273018|9267991740666|9267982106874|9267992232186|9267982762234|9267992690938|9267983614202|9267993084154|9267984236794|9267993641210|9267985809658|9267980140794|9267994165498|9267987251450|9267994689786|9267988791546|9267981189370|9267979190522|9267995148538|9267989545210|9267995869434|9267990233338|9267996492026|9267990921466|8930974204154|9267996983546|9267997278458|9267964051706|9268000784634|9267968803066|9268001308922|9267964641530|9268033716474|9267965198586|9268034175226|9267965657338|9268034535674|9267966542074|9268034994426|9267967721722|9267959693562|9267997671674|9267969917178|9267960611066|9267972800762|9267961495802|9267974635770|9267962544378|9267998163194|9267975487738|9267963003130|9267976241402|9267963461882|9238056075514|9267977060602|9267977879802|9268039942394|9267994788090|9268040368378|9267995214074|9268040859898|9267995672826|9268041285882|9267996262650|9268041679098|9267996721402|9268042105082|9267997147386|9268042465530|9267997475066|9268042924282|9267997835514|9267981549818|9268043350266|9267999015162|9268044792058|9267999965434|9268045218042|9268000751866|9267983450362|9267985907962|9267988922618|9267987218682|9268038107386|9268038566138|9267984171258|9268045644026|9268001407226|8934371229946|9238055059706|9238055878906|9238055780602|9268046102778|9268046495994|9268053573882|9268047970554|9268054524154|9268048331002|9268054950138|9268049084666|9268046758138|9268055343354|9268049445114|9268057669882|9268049936634|9268055834874|9268050460922|9268047118586|9268056588538|9268051181818|9268057047290|9268051771642|9268058358010|9268052295930|9268058816762|9268052721914|9268059341050|9268053115130|8934697304314|8932910498042|8940566184186|8685183631610|8926356832506|8926295982330|8934698713338|8938087022842|8921139249402|8907323769082|8919098196218|8919066476794|8918949363962|8912696738042|8907309089018|8919082369274|8938090332410|8931009593594|8940564381946|8931013460218|8919682416890|8934350389498|8920421695738|8931008905466|8931009396986|8925676306682|8925676339450|8926362861818|8926362894586|8938079289594|8931006251258|8940569854202|8955587002618|8957833511162|8957826597114|8957836525818|8927209292026|8926076272890|8926023352570|8926013161722|8926020043002|8925614342394|8940556714234|8927209718010|8927211225338|8927212765434|8925476651258|8921195315450|8926273896698|8905709322490|8731874492666|8915382206714|8938089742586|8923780088058|8940998066426|8931010937082|8924457074938|8907251515642|8904234762490|8907271438586|8903498694906|8907299127546|8905773187322|8907323310330|8907289198842|8907326324986|8905772531962|8937431826682|8915382894842|8923778449658|8919677763834|8920380932346|8920268439802|8920267784442|8930974335226|8938088464634|8914265080058|8914281529594|8914245157114|8914210128122|8919051600122|8915383812346|8923778547962|8925481926906|8938175561978|8934702809338|9267875447034|8938176610554|8957294018810|8927195037946|8927196545274|8927195201786|8927210635514|8921122963706|8921122996474|8927195332858|8921123127546|8921123258618|8927199035642|8927199265018|8927199461626|8921123193082|8927199691002|8926912413946|8921122930938|8957841309946|8930975023354|8972067111162|8921194561786|8923778384122|8957266166010|8957277241594|8931006972154|8934107513082|8940572901626|8934702481658|8934258147578|8915398590714|8549981946106|8937406988538|8938079191290|8719765373178|8929287471354|8931011166458|8731141177594|8934281117946|8924437053690|8934216499450|8925587144954|8925587177722|8925587112186|8925587046650|8925586948346|8925586981114|8915381813498|8905662660858|8905702670586|8905703588090|8904188657914|8920400560378|8938088857850|8934702186746|8912827056378|8912808542458|8919100850426|8920464851194|8920452497658|8912701063418|8921210781946|8957872341242|8938172678394|8938088136954|8924437151994|8924457861370|8924424175866|8924436955386|8905794912506|8929286193402|8921198395642|8957304930554|8937397747962|8931013591290|8941035389178|8934696943866'.split('|'));
  const wrapperSelector = '.selector-wrapper, .bcpo-selector-wrapper, .bold_option, [data-option]';

  const normalize = (value) => String(value || '')
    .replace(/\s*\*+\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const init = (root) => {
    if (root.dataset.fdRequiredHelpReady === 'true') return;
    const form = root.querySelector('.fd-pdp-form');
    if (!form) return;
    root.dataset.fdRequiredHelpReady = 'true';

    const variantInput = root.querySelector('[data-fd-variant-id]');
    const variantsNode = root.querySelector('[data-fd-variants-json]');
    let variants = [];
    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (_) {
      variants = [];
    }

    let snapshot = null;
    let mainOriginal = null;
    let stickyOriginal = null;
    let mainHelp = null;
    let stickyHelp = null;
    let feedback = null;
    let frame = 0;
    const marked = new Map();

    const getBcpoRoot = () => root.querySelector('#bcpo') || (
      document.querySelectorAll('[data-fd-product]').length === 1 ? document.querySelector('#bcpo') : null
    );

    const currentSnapshot = () => {
      const variantId = String(variantInput ? variantInput.value || '' : '');
      if (
        snapshot
        && snapshot.state === root.dataset.fdPriceState
        && String(snapshot.variantId || '') === variantId
      ) return snapshot;
      const globalSnapshot = window.FDConfiguredPrice;
      if (
        globalSnapshot
        && globalSnapshot.state === root.dataset.fdPriceState
        && String(globalSnapshot.variantId || '') === variantId
      ) {
        return globalSnapshot;
      }
      return null;
    };

    const variantAvailable = () => {
      if (!variantInput || !variants.length) return false;
      const variant = variants.find((item) => String(item.id) === String(variantInput.value || ''));
      return Boolean(variant && variant.available !== false);
    };

    const eligible = () => {
      const current = currentSnapshot();
      return Boolean(
        current
        && current.state === 'incomplete'
        && root.dataset.fdPriceState === 'incomplete'
        && Array.isArray(current.incompleteTitles)
        && current.incompleteTitles.length > 0
        && root.dataset.fdOnlineStorePublished !== 'false'
        && (!root.dataset.fdConditionalState || root.dataset.fdConditionalState === 'clean')
        && root.dataset.fdVoMappingError !== 'true'
        && variantAvailable()
      );
    };

    const isVisible = (element) => {
      if (!element || !element.isConnected) return false;
      if (element.closest('[hidden], [aria-hidden="true"], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden')) {
        return false;
      }
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    };

    const controlsIn = (field) => Array.from(field.querySelectorAll('input, select, textarea'))
      .filter((control) => (
        !control.disabled
        && control.type !== 'hidden'
        && !String(control.name || '').includes('[_fd_')
      ));

    const hasControlValue = (control) => {
      if (control.tagName === 'SELECT') {
        const selected = control.options[control.selectedIndex];
        const value = String(control.value == null ? '' : control.value).trim();
        const label = normalize(selected ? selected.textContent : '');
        return Boolean(
          value
          && selected
          && !selected.disabled
          && selected.dataset.placeholder !== 'true'
          && !['choose one', 'select one', 'select', '选择一个'].includes(label)
        );
      }
      if (control.type === 'file') return Boolean(control.files && control.files.length);
      return String(control.value == null ? '' : control.value).trim() !== ''
        && (typeof control.checkValidity !== 'function' || control.checkValidity());
    };

    const firstMissingControl = (field, controls = controlsIn(field)) => {
      if (!controls.length) return null;
      for (const type of ['radio', 'checkbox']) {
        const choices = controls.filter((control) => control.type === type);
        if (choices.length && !choices.some((control) => (
          control.checked && (type === 'checkbox' || String(control.value || '').trim() !== '')
        ))) return choices[0];
      }
      return controls.find((control) => !['radio', 'checkbox'].includes(control.type) && !hasControlValue(control)) || null;
    };

    const fieldTitle = (field) => {
      const heading = field.querySelector('.bcpo-title, .bcpo-label, .bold_option_title, legend, label');
      return String(
        field.dataset.optionTitle || field.dataset.option || field.dataset.bcpoOption
        || (heading && heading.textContent) || ''
      ).replace(/\s*\*+\s*$/, '').replace(/\s+/g, ' ').trim();
    };

    const matchingVisibleTemplateFields = (title) => Array.from(root.querySelectorAll('[data-fd-vo-template-field]'))
      .map((field) => {
        if (!isVisible(field) || field.hasAttribute('data-fd-vo-optional-field')) return null;
        const controls = controlsIn(field);
        const matchingControls = controls.filter((control) => normalize(control.dataset.fdVoOption) === normalize(title));
        const control = matchingControls.length
          ? firstMissingControl(field, matchingControls)
          : normalize(fieldTitle(field)) === normalize(title)
            ? firstMissingControl(field, controls)
            : null;
        return control ? { field, control } : null;
      }).filter(Boolean);

    const missingFields = () => {
      const current = currentSnapshot();
      const titles = current && Array.isArray(current.incompleteTitles) ? current.incompleteTitles : [];
      const bcpo = getBcpoRoot();
      if (!bcpo || !titles.length) return [];
      const wrappers = Array.from(bcpo.querySelectorAll(wrapperSelector));
      const result = [];
      const seen = new Set();
      const append = (field, control, title) => {
        if (!field || !control || seen.has(control)) return;
        seen.add(control);
        result.push({ field, control, title: String(title) });
      };
      titles.forEach((title) => {
        const matches = wrappers.filter((candidate) => (
          isVisible(candidate)
          && normalize(fieldTitle(candidate)) === normalize(title)
          && firstMissingControl(candidate)
        ));
        if (matches.length) {
          matches.forEach((field) => append(field, firstMissingControl(field), title));
        } else {
          matchingVisibleTemplateFields(title).forEach(({ field, control }) => append(field, control, title));
        }
      });
      return result.sort((a, b) => {
        const order = a.control.compareDocumentPosition(b.control);
        return order & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : order & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
      });
    };

    const clearMark = (control) => {
      const record = marked.get(control);
      if (!record) return;
      const { field, invalidBefore, wroteInvalid, error } = record;
      if (control && control.isConnected) {
        control.classList.remove('fd-required-options-control-missing');
        if (wroteInvalid && control.getAttribute('aria-invalid') === 'true') {
          if (invalidBefore === null) control.removeAttribute('aria-invalid');
          else control.setAttribute('aria-invalid', invalidBefore);
        }
        const remainingDescriptions = String(control.getAttribute('aria-describedby') || '')
          .split(/\s+/)
          .filter((id) => id && id !== error.id);
        if (remainingDescriptions.length) control.setAttribute('aria-describedby', remainingDescriptions.join(' '));
        else control.removeAttribute('aria-describedby');
      }
      if (error && error.isConnected) error.remove();
      marked.delete(control);
      if (!Array.from(marked.values()).some((entry) => entry.field === field)) {
        field.classList.remove('fd-required-options-missing');
        if (field.hasAttribute('data-fd-required-added-tabindex')) {
          field.removeAttribute('tabindex');
          field.removeAttribute('data-fd-required-added-tabindex');
        }
      }
    };

    const clearMarks = () => Array.from(marked.keys()).forEach(clearMark);

    const markMissing = (items) => {
      const next = new Set(items.map((item) => item.control));
      Array.from(marked.keys()).forEach((control) => {
        if (!next.has(control)) clearMark(control);
      });
      items.forEach(({ field, control, title }) => {
        const existing = marked.get(control);
        if (existing && (existing.field !== field || !existing.error.isConnected)) clearMark(control);
        else if (existing) {
          field.classList.add('fd-required-options-missing');
          control.classList.add('fd-required-options-control-missing');
          existing.error.textContent = `Please complete ${title} before adding to cart.`;
          if (control.getAttribute('aria-invalid') !== 'true') {
            control.setAttribute('aria-invalid', 'true');
            existing.wroteInvalid = true;
          }
          const descriptions = String(control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          if (!descriptions.includes(existing.error.id)) {
            descriptions.push(existing.error.id);
            control.setAttribute('aria-describedby', descriptions.join(' '));
          }
          return;
        }
        const error = document.createElement('p');
        error.className = 'fd-required-options-field-error';
        error.id = `fd-required-options-${Math.random().toString(36).slice(2, 10)}`;
        error.textContent = `Please complete ${title} before adding to cart.`;
        field.appendChild(error);
        field.classList.add('fd-required-options-missing');
        control.classList.add('fd-required-options-control-missing');
        const invalidBefore = control.getAttribute('aria-invalid');
        const wroteInvalid = invalidBefore !== 'true';
        if (wroteInvalid) control.setAttribute('aria-invalid', 'true');
        const descriptions = String(control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (!descriptions.includes(error.id)) descriptions.push(error.id);
        control.setAttribute('aria-describedby', descriptions.join(' '));
        marked.set(control, { field, invalidBefore, wroteInvalid, error });
      });
    };

    const showFeedback = (message) => {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.hidden = false;
    };

    const hideFeedback = () => {
      if (!feedback) return;
      feedback.textContent = '';
      feedback.hidden = true;
    };

    const scrollToFirst = (item) => {
      const { field, control } = item;
      const focusTarget = isVisible(control) ? control : field;
      if (focusTarget === field && !field.hasAttribute('tabindex')) {
        field.setAttribute('tabindex', '-1');
        field.setAttribute('data-fd-required-added-tabindex', '');
      }
      if (typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      const header = Array.from(document.querySelectorAll('[data-fd-global-header], .site-header, header'))
        .find((node) => isVisible(node) && node.getBoundingClientRect().top <= 8);
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const offset = Math.max(headerBottom + 20, 80);
      const top = Math.max(0, window.scrollY + field.getBoundingClientRect().top - offset);
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
    };

    const reviewMissing = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!eligible()) return;
      const items = missingFields();
      if (!items.length) {
        clearMarks();
        showFeedback('Please wait while we confirm your custom options.');
        return;
      }
      markMissing(items);
      showFeedback(`Please complete the highlighted required ${items.length === 1 ? 'option' : 'options'} before adding to cart.`);
      scrollToFirst(items[0]);
    };

    const makeHelp = (original, location) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fd-required-options-help';
      button.setAttribute('data-fd-required-help', location);
      button.setAttribute('aria-label', 'Add to cart; review missing required options');
      button.textContent = 'Add to Cart';
      button.hidden = true;
      original.insertAdjacentElement('afterend', button);
      button.addEventListener('click', reviewMissing);
      return button;
    };

    const ensureButtons = () => {
      const nextMain = root.querySelector('[data-fd-atc]');
      const nextSticky = root.querySelector('[data-fd-sticky-submit]');
      if (nextMain && nextMain !== mainOriginal) {
        if (mainOriginal) mainOriginal.removeAttribute('data-fd-required-original-hidden');
        if (mainHelp) mainHelp.remove();
        if (feedback) feedback.remove();
        mainOriginal = nextMain;
        mainHelp = makeHelp(nextMain, 'main');
        feedback = document.createElement('p');
        feedback.id = `fd-required-options-summary-${Math.random().toString(36).slice(2, 10)}`;
        feedback.className = 'fd-required-options-summary';
        feedback.setAttribute('role', 'alert');
        feedback.hidden = true;
        mainHelp.insertAdjacentElement('afterend', feedback);
        mainHelp.setAttribute('aria-describedby', feedback.id);
      }
      if (nextSticky && nextSticky !== stickyOriginal) {
        if (stickyOriginal) stickyOriginal.removeAttribute('data-fd-required-original-hidden');
        if (stickyHelp) stickyHelp.remove();
        stickyOriginal = nextSticky;
        stickyHelp = makeHelp(nextSticky, 'sticky');
      }
      if (stickyHelp && feedback) stickyHelp.setAttribute('aria-describedby', feedback.id);
    };

    const updateInlineVisibility = () => {
      if (!mainHelp || mainHelp.hidden) {
        root.dataset.fdRequiredMainVisible = 'false';
        return;
      }
      const rect = mainHelp.getBoundingClientRect();
      root.dataset.fdRequiredMainVisible = rect.top < window.innerHeight - 16 && rect.bottom > 16 ? 'true' : 'false';
    };

    const sync = () => {
      frame = 0;
      ensureButtons();
      const show = eligible() && missingFields().length > 0;
      [[mainOriginal, mainHelp], [stickyOriginal, stickyHelp]].forEach(([original, help]) => {
        if (!original || !help) return;
        if (show) original.setAttribute('data-fd-required-original-hidden', '');
        else original.removeAttribute('data-fd-required-original-hidden');
        help.hidden = !show;
      });
      if (!show) {
        clearMarks();
        hideFeedback();
      } else if (marked.size) {
        markMissing(missingFields());
      }
      updateInlineVisibility();
    };

    const scheduleSync = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(sync);
    };

    root.addEventListener('fd:configured-price', (event) => {
      if (event.target !== root) return;
      snapshot = event.detail || null;
      sync();
    });
    root.addEventListener('input', scheduleSync, true);
    root.addEventListener('change', sync, true);
    root.addEventListener('click', (event) => {
      if (event.target.closest && event.target.closest('#bcpo, [data-fd-vo-template-field]')) scheduleSync();
    }, true);
    const onExternalOptionInteraction = (event) => {
      const bcpo = getBcpoRoot();
      if (bcpo && !root.contains(bcpo) && bcpo.contains(event.target)) {
        if (event.type === 'change') sync();
        else scheduleSync();
      }
    };
    document.addEventListener('input', onExternalOptionInteraction, true);
    document.addEventListener('change', onExternalOptionInteraction, true);
    document.addEventListener('click', onExternalOptionInteraction, true);
    window.addEventListener('scroll', () => window.requestAnimationFrame(updateInlineVisibility), { passive: true });
    window.addEventListener('resize', () => window.requestAnimationFrame(updateInlineVisibility), { passive: true });

    const observer = new MutationObserver((records) => {
      if (records.some((record) => (
        record.type === 'attributes'
        || Array.from(record.addedNodes || []).some((node) => (
          node.nodeType === 1 && (
            node.matches('#bcpo, [data-fd-atc], [data-fd-sticky-submit]')
            || node.querySelector('#bcpo, [data-fd-atc], [data-fd-sticky-submit]')
          )
        ))
      ))) scheduleSync();
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: ['data-fd-price-state', 'data-fd-vo-mapping-error'],
      childList: true,
      subtree: true
    });

    sync();
  };

  const run = () => document.querySelectorAll(rootSelector).forEach((root) => {
    if (allowedProductIds.has(String(root.dataset.productId || ''))) init(root);
  });
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
